import React, { forwardRef, type HTMLProps } from 'react';

import styles from './VisuallyDisabled.module.scss';

/*
 * Tooltips don't work on disabled elements since their event handlers are blocked.
 * This wraps the child in a div to allow the tooltip to work.
 */
export const VisuallyDisabled = forwardRef<HTMLDivElement, HTMLProps<HTMLDivElement>>(
    ({ children, ...props }: HTMLProps<HTMLDivElement>, ref) => (
        <div ref={ref} className={styles.disabled} onClick={(e) => e.preventDefault()} {...props}>
            {children}
        </div>
    )
);
VisuallyDisabled.displayName = 'VisuallyDisabled';
